// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { QuestionnaireStepContentContentFragmentDoc } from './content/QuestionnaireStepContentContent.fragment.generated';
import { BlockFragmentDoc } from '../../CmsBlock.fragment.generated';
import { QuestionnaireConditionFragmentDoc } from './condition/QuestionnaireCondition.fragment.generated';
import { QuestionnaireStepContentQuestionsFragmentDoc } from './question/QuestionnaireStepContentQuestions.fragment.generated';
export const QuestionnaireStepFragmentDoc = gql`
    fragment questionnaireStep on QuestionnaireStep {
  __typename
  title
  description
  content {
    ...questionnaireStepContentContent
    ...questionnaireStepContentQuestions
  }
  conditions {
    ...questionnaireCondition
  }
  help {
    ...block
  }
  excludeFromProgressIndicator
}
    ${QuestionnaireStepContentContentFragmentDoc}
${QuestionnaireStepContentQuestionsFragmentDoc}
${QuestionnaireConditionFragmentDoc}
${BlockFragmentDoc}`;